// extracted by mini-css-extract-plugin
export default {"button":"DishesTableBarCode_button__c6E22","placeHolderShimmer":"DishesTableBarCode_placeHolderShimmer__SLrQZ"};